import { useTranslation } from 'react-i18next'

export interface Stage {
  key: string
  /** Two-digit number rendered as `step-num` ("01" … "13"). */
  num: string
  /** Short uppercase label for the chip. Falls back to the translation key. */
  labelKey: string
}

/**
 * The 13 intake stages, in canonical order. Matches the original
 * `lorenza.html` data-section order so the stepper labels line up 1:1.
 */
export const STAGES: Stage[] = [
  { key: 'strategic',    num: '01', labelKey: 'intake.stepper.strategic' },
  { key: 'users',        num: '02', labelKey: 'intake.stepper.users' },
  { key: 'ai',           num: '03', labelKey: 'intake.stepper.ai' },
  { key: 'data',         num: '04', labelKey: 'intake.stepper.data' },
  { key: 'security',     num: '05', labelKey: 'intake.stepper.security' },
  { key: 'memory',       num: '06', labelKey: 'intake.stepper.memory' },
  { key: 'integrations', num: '07', labelKey: 'intake.stepper.integrations' },
  { key: 'scalability',  num: '08', labelKey: 'intake.stepper.scalability' },
  { key: 'governance',   num: '09', labelKey: 'intake.stepper.governance' },
  { key: 'operations',   num: '10', labelKey: 'intake.stepper.operations' },
  { key: 'ux',           num: '11', labelKey: 'intake.stepper.ux' },
  { key: 'delivery',     num: '12', labelKey: 'intake.stepper.delivery' },
  { key: 'generate',     num: '13', labelKey: 'intake.stepper.generate' },
]

interface StepperProps {
  active: string
  completed?: Set<string>
  onSelect?: (key: string) => void
}

export function Stepper({ active, completed, onSelect }: StepperProps) {
  const { t } = useTranslation()
  return (
    <nav className="stepper" aria-label="Intake stages">
      {STAGES.map((s) => {
        const isActive = s.key === active
        const isDone = completed?.has(s.key) ?? false
        const cls = `step${isActive ? ' active' : ''}${isDone && !isActive ? ' completed' : ''}`
        return (
          <button
            type="button"
            key={s.key}
            className={cls}
            onClick={() => onSelect?.(s.key)}
            aria-current={isActive ? 'step' : undefined}
          >
            <span className="step-num">{s.num}</span>
            <span className="step-label">{t(s.labelKey, s.key)}</span>
          </button>
        )
      })}
    </nav>
  )
}
